export default "__VITE_ASSET__c5405189__"